import { ShieldCheck } from "lucide-react";
import { TRUST_ITEMS } from "../../data/content";

const Marquee = () => (
  <section className="bg-slate-50 dark:bg-[#0A1030] border-y border-slate-100 dark:border-white/5 py-7 overflow-hidden" data-testid="trust-marquee" aria-label="Trust commitments">
    <div className="flex w-max animate-marquee gap-0 will-change-transform hover:[animation-play-state:paused]">
      {[...TRUST_ITEMS, ...TRUST_ITEMS].map((item, i) => (
        <div key={i} className="flex items-center gap-3 px-10 shrink-0">
          <ShieldCheck size={15} className="text-brand-sky shrink-0" />
          <span className="font-display text-sm md:text-base font-semibold tracking-wide text-slate-500 dark:text-slate-400 whitespace-nowrap uppercase">
            {item}
          </span>
        </div>
      ))}
    </div>
  </section>
);
export default Marquee;
